import { TokensModel } from '@vp/auth/core/model/TokensModel';

export abstract class TokensStorage {
  abstract store(tokens: TokensModel): Promise<void>;
  abstract retrieve(): Promise<TokensModel | null>;
  abstract clear(): Promise<void>;
}
